module.exports = __webpack_public_path__ + "bcae85074dbbb6174c5b787f8a09ac2e.MP3";